import { useQuery } from '@tanstack/react-query';
import { client } from '../../../../api/generated/client.gen';
import { GridData, parseGridBinary } from '../modelAreaCoordinates.utils';
import { queryKeys } from '../../../../hooks/queryKeys';

export const useArchelGrid = (modelId: string | undefined) => {
  return useQuery<GridData>({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.archelGrid(modelId as string),
    queryFn: async () => {
      const response = await client.instance.get<ArrayBuffer>(
        `/api/v1/analogue-models/${modelId}/archel-grid`,
        {
          responseType: 'arraybuffer',
          decompress: true,
        },
      );
      return parseGridBinary(response.data);
    },
    enabled: !!modelId,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
    retry: 1,
  });
};
